import React, { useState, useEffect } from "react";
import { Carousel } from "react-bootstrap";
import {
  FaHandshake,
  FaBriefcase,
  FaCalendarAlt,
  FaUsers,
} from "react-icons/fa";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import CountUp from "react-countup";
import { getAll } from "../../api/API";

const slides = [
  {
    image: "assets/images/Component 48.svg",
    text: "Mentorship",
    icon: <FaHandshake size={60} className="mb-2" />,
  },
  {
    image: "assets/images/Component 70.svg",
    text: "Find a Job",
    icon: <FaBriefcase size={60} className="mb-2" />,
  },
  {
    image: "/assets/images/Component 72.png",
    text: "Events",
    icon: <FaCalendarAlt size={60} className="mb-2" />,
  },
  {
    image: "assets/images/Component 73.svg",
    text: "Community",
    icon: <FaUsers size={60} className="mb-2" />,
  },
];

const HeroCarousel = () => {
  const [index, setIndex] = useState(0);
  const [hoverPrev, setHoverPrev] = useState(false);
  const [hoverNext, setHoverNext] = useState(false);
  const [stats, setStats] = useState([
    { label: "Members", value: 0 },
    { label: "Mentors", value: 0 },
  ]);
  const [loading, setLoading] = useState(true);

  const handleSelect = (selectedIndex) => setIndex(selectedIndex);
  const handlePrev = () => index > 0 && setIndex(index - 1);
  const handleNext = () => index < slides.length - 1 && setIndex(index + 1);

  // Fetch stats from API
  useEffect(() => {
    (async () => {
      try {
        const data = await getAll("/members/stats");
        const formattedStats = [
          { label: "Members", value: data.totalMembers },
          { label: "Mentors", value: data.totalMentors },
        ];
        setStats(formattedStats);
      } catch (error) {
        console.error("Error fetching member stats:", error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="hero-carousel h-100 w-100 position-relative">
      <Carousel
        activeIndex={index}
        onSelect={handleSelect}
        className="h-100"
        indicators={false}
        controls={false}
        interval={2000}
        touch
        slide
        pause={false}
      >
        {slides.map((slide, i) => (
          <Carousel.Item key={i} className="h-100 position-relative">
            <img
              src={slide.image}
              alt={`Slide ${i + 1}`}
              className="d-block w-100 h-100"
              style={{ objectFit: "cover", opacity: 0.8 }}
            />
            <div
              className="overlay"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0,0,0,0.3)",
                zIndex: 5,
              }}
            />
            <div
              className="position-absolute top-50 start-50 translate-middle text-white text-center d-flex flex-column align-items-center"
              style={{ zIndex: 10, textShadow: "0 0 10px rgba(0,0,0,0.7)" }}
            >
              {slide.icon}
              <h2 className="fw-bold">{slide.text}</h2>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>

      {/* Stats Overlay Card */}
      <div className="stats-card">
        {[
          ...stats,
          // { label: "YOE", value: 25 },
          // { label: "Projects", value: 30 },
        ].map((stat, i) => (
          <div key={i} className="stat-item text-primary">
            <h3 className="fw-bold mb-0">
              <CountUp
                end={loading ? 0 : stat.value}
                duration={1.8}
                suffix="+"
              />
            </h3>
            <p className="mb-0">{stat.label}</p>
          </div>
        ))}
      </div>

      {/* Prev Button  */}
      <button
        className={`carousel-control-prev btn-left  ${
          hoverPrev ? "hovered" : ""
        } ${index === 0 ? "disabled" : ""}`}
        onClick={handlePrev}
        disabled={index === 0}
        aria-label="Previous slide"
        onMouseEnter={() => setHoverPrev(true)}
        onMouseLeave={() => setHoverPrev(false)}
      >
        <div className="icon-circle carousel-btn-icon">
          <BsChevronLeft
            size={50}
            style={{ color: "#2c0446" }}
            aria-hidden="true"
          />
        </div>
      </button>

      {/* Next Button */}
      <button
        className={`carousel-control-next btn-right ${
          hoverNext ? "hovered" : ""
        } ${index === slides.length - 1 ? "disabled" : ""}`}
        onClick={handleNext}
        disabled={index === slides.length - 1}
        aria-label="Next slide"
        onMouseEnter={() => setHoverNext(true)}
        onMouseLeave={() => setHoverNext(false)}
      >
        <div className="icon-circle carousel-btn-icon">
          <BsChevronRight
            size={32}
            style={{ color: "#2c0446" }}
            aria-hidden="true"
          />
        </div>
      </button>
    </div>
  );
};

export default HeroCarousel;
